import {Badge} from '@mantine/core'
import {useProjects} from '../../../../providers/projects/useProjects.ts'
import {IconArchive, IconCircleFilled} from '@tabler/icons-react'

type Props = {
  projectId: string
  compact?: boolean
}

export const ProjectBadge = ({projectId, compact = false}: Props) => {
  const {projects} = useProjects()
  const project = projects.find((project) => project.id === projectId)
  if (!project) return null

  const icon = project.archivedTime ? (
    <IconArchive color={project.color} size={14} />
  ) : (
    <IconCircleFilled color={project.color} size={14} />
  )

  if (compact)
    return (
      <Badge size={'md'} variant={'light'} title={`Project: ${project.name}`} pt={5} circle>
        {icon}
      </Badge>
    )

  return (
    <Badge
      size={'lg'}
      variant={'light'}
      title={`Project: ${project.name}`}
      style={{fontWeight: 'normal', textTransform: 'none', pointerEvents: 'none'}}
      pl={8}
      leftSection={icon}
    >
      {project.name}
    </Badge>
  )
}
